export const isSafari = () => {
  const userAgent = window.navigator.userAgent.toLowerCase();
  return (
    userAgent.includes('safari') &&
    !userAgent.includes('chrome') &&
    !userAgent.includes('firefox')
  );
};

export const isTouchDevice = () => {
  return (
    'ontouchstart' in window ||
    navigator.maxTouchPoints > 0 ||
    window.matchMedia('(pointer: coarse)').matches
  );
};

export const isMacOS = () => {
  const userAgent = window.navigator.userAgent.toLowerCase();
  return (
    (userAgent.includes('macintosh') || userAgent.includes('mac os x')) &&
    !userAgent.includes('iphone') &&
    !userAgent.includes('ipad') &&
    !userAgent.includes('ipod')
  );
};

export type Platform = 'ios' | 'android' | 'other';

export function detectPlatform(): Platform {
  if (typeof navigator === 'undefined') {
    return 'other';
  }

  const ua = navigator.userAgent || '';
  const uaData = (navigator as any).userAgentData;
  const maxTouchPoints = (navigator as any).maxTouchPoints ?? 0;

  if (uaData && typeof uaData.platform === 'string') {
    const p = uaData.platform.toLowerCase();
    if (p.includes('ios')) return 'ios';
    if (p.includes('android')) return 'android';
  }

  if (
    /iPad|iPhone|iPod/.test(ua) ||
    (/Macintosh/.test(ua) && maxTouchPoints > 1)
  ) {
    return 'ios';
  }

  if (/android/i.test(ua)) {
    return 'android';
  }

  return 'other';
}
